export const floatingPointSafeCalculation = (num: number) => {
  // This is needed to handle JS floating point arithmetic
  // https://stackoverflow.com/questions/11832914/round-to-at-most-2-decimal-places-only-if-necessary
  return Math.round((num + Number.EPSILON) * 100) / 100;
};
